export const DAYS_UNTIL_RENEWAL_THRESHOLD = 60;
export const DAYS_UNTIL_RENEWAL_BUTTON_APPEARANCE_THRESHOLD = 180;
